module.exports = __webpack_public_path__ + "static/media/logo-에이치랩@2x.79daf48e.png";